//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'llFooter',
  components: {},
  props: {},
  data () {
    return {}
  }
}
